import axiosInstance from '@/utils/api.js'

var state = {
  chargePolicies: []
}

var getters = {
  CHARGE_POLICIES: (state) => {
    return state.chargePolicies
  }
}

var mutations = {
  SET_CHARGE_POLICIES: (state, payload) => {
    state.chargePolicies = payload
  }
}

var actions = {
  GET_CHARGE_POLICIES: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/charge_polices')
    if (result.status === 200) {
      context.commit('SET_CHARGE_POLICIES', result.data)
    }
  },
  CREATE_CHARGE_POLICIES: (context, payload) => {
    return axiosInstance.post('/tariffing/charge_policy', payload)
  },
  UPDATE_CHARGE_POLICIES: (context, payload) => {
    return axiosInstance.put('/tariffing/charge_policy', payload)
  },
  DELETE_CHARGE_POLICIES: (context, payload) => {
    return axiosInstance.delete('/tariffing/charge_policy?policy_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/chargePolicies.js